import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEdit3, FiCode, FiZap, FiTool, FiGrid, FiList } = FiIcons;

const ToolsNavigation = ({ activeCategory, setActiveCategory, viewMode, setViewMode }) => {
  const categories = [
    { id: 'all', name: 'All Tools', icon: FiGrid },
    { id: 'content', name: 'Content Creation', icon: FiEdit3 },
    { id: 'website', name: 'Website Building', icon: FiCode },
    { id: 'automation', name: 'Marketing Automation', icon: FiZap },
    { id: 'business', name: 'Business Tools', icon: FiTool }
  ];

  return (
    <div className="bg-gradient-to-r from-gray-800/40 to-gray-900/40 p-6 rounded-2xl border border-gray-700/30 backdrop-blur-sm mb-8">
      <div className="flex flex-col lg:flex-row items-center justify-between space-y-4 lg:space-y-0">
        {/* Categories */}
        <div className="flex flex-wrap items-center gap-2">
          {categories.map((category) => (
            <motion.button
              key={category.id}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setActiveCategory(category.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-full font-poppins font-medium transition-all duration-300 ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-cyan-600 to-blue-600 text-white'
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50'
              }`}
            >
              <SafeIcon icon={category.icon} className="text-sm" />
              <span className="text-sm">{category.name}</span>
            </motion.button>
          ))}
        </div>

        {/* View Mode Toggle */}
        <div className="flex items-center space-x-2 bg-gray-700/50 rounded-full p-1">
          <button
            onClick={() => setViewMode('grid')}
            className={`p-2 rounded-full transition-all duration-300 ${
              viewMode === 'grid'
                ? 'bg-cyan-600 text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <SafeIcon icon={FiGrid} className="text-sm" />
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`p-2 rounded-full transition-all duration-300 ${
              viewMode === 'list'
                ? 'bg-cyan-600 text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <SafeIcon icon={FiList} className="text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToolsNavigation;